import * as React from 'react'
import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import Container from '@mui/material/Container'
import Link from '@mui/material/Link'

import FacebookIcon from '@mui/icons-material/Facebook'
import TwitterIcon from '@mui/icons-material/Twitter'
import LinkedInIcon from '@mui/icons-material/LinkedIn'
import InstagramIcon from '@mui/icons-material/Instagram'

//const pages = ['Products', 'Pricing', 'Blog'];
//const settings = ['Profile', 'Account', 'Dashboard', 'Logout'];
const pages = []
const settings = []

function ResponsiveAppBar() {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <AppBar position="static" sx={{maxHeight: '36px', backgroundColor: '#C71C1C'}}>
      <Container maxWidth="xl">
        
        <Link href='https://www.facebook.com/nativemaine' target='_BLANK' sx={{ color: 'white' }}>
          <FacebookIcon sx={{ marginTop: '6px' }}></FacebookIcon>
        </Link>
        &nbsp;&nbsp;

        <Link href='https://twitter.com/nativemaine' target='_BLANK' sx={{ color: 'white' }}>
          <TwitterIcon sx={{ marginTop: '6px' }}></TwitterIcon>
        </Link>
        &nbsp;&nbsp;

        <Link href='https://www.linkedin.com/company/4002166' target='_BLANK' sx={{ color: 'white' }}>
          <LinkedInIcon sx={{ marginTop: '6px' }}></LinkedInIcon>
        </Link>
        &nbsp;&nbsp;

        <Link href='https://www.instagram.com/nativemaineproduce/' target='_BLANK' sx={{ color: 'white' }}>
          <InstagramIcon sx={{ marginTop: '6px' }}></InstagramIcon>
        </Link>
        
        <Toolbar disableGutters>
          
        </Toolbar>

      </Container>
    </AppBar>
  );
}
export default ResponsiveAppBar;